import { render, staticRenderFns } from "./ProposalTabPage.vue?vue&type=template&id=020bdfa7"
import script from "./ProposalTabPage.vue?vue&type=script&lang=js"
export * from "./ProposalTabPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports